import { useId } from 'react';
import { StyleSheet } from 'react-native';
import Svg, { ClipPath, Defs, G, Mask, Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => {
    const uid = useId();
    const clipId = `${uid}-clip`;
    const maskId = `${uid}-mask`;

    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width ?? 16}
            height={props.height ?? 16}
            fill="none"
            {...props}
        >
            <Defs>
                <ClipPath id={clipId}>
                    <Path fill="#fff" d="M1.5 1.5h13v13h-13z" />
                </ClipPath>
            </Defs>
            <G clipPath={`url(#${clipId})`}>
                <Mask
                    id={maskId}
                    width={14}
                    height={14}
                    x={1}
                    y={1}
                    maskUnits="userSpaceOnUse"
                    style={styles.luminance}
                >
                    <Path fill="#fff" d="M14.5 1.5h-13v13h13v-13Z" />
                </Mask>
                <G fill={ds.colorValue.icon.inverse} mask={`url(#${maskId})`}>
                    <Path d="m7.11 10.6-1.48 3.9c-.84-.34-1.6-.85-2.22-1.5A6.791 6.791 0 0 1 1.5 8.24h3.76c.03.3.1.58.21.84 0 .01.01.01.01.01.14.34.35.63.57.85.26.25.57.47.95.62 0 0 .01 0 .01.01.03.01.06.02.1.03ZM12.6 3.47l-2.57 2.67s-.05-.06-.08-.09c-.26-.25-.57-.47-.95-.61 0-.01-.01-.01-.01-.01a2.779 2.779 0 0 0-2.07.04l-.02.01c-.34.14-.62.34-.85.57-.03.03-.06.06-.08.09L3.4 3.47c.57-.59 1.25-1.07 2-1.41.8-.36 1.67-.56 2.6-.56.84 0 1.64.16 2.38.47.84.34 1.59.86 2.22 1.5ZM14.5 8.24c0 .87-.16 1.7-.45 2.46-.33.87-.83 1.65-1.46 2.3-.57.59-1.24 1.08-1.99 1.42l-1.62-3.86s.07-.02.1-.04h.02c.34-.14.62-.35.85-.58.25-.25.47-.57.62-.95.09-.24.15-.49.17-.75h3.76ZM9.75 8c0 .22-.04.44-.12.64-.09.23-.22.43-.39.6-.15.15-.33.28-.54.37a1.732 1.732 0 0 1-1.34.03 1.73 1.73 0 0 1-.6-.39c-.15-.15-.28-.33-.37-.54a1.732 1.732 0 0 1-.03-1.34c.09-.23.22-.43.39-.6.15-.15.33-.28.54-.37a1.732 1.732 0 0 1 1.34-.03c.23.09.43.22.6.39.15.15.28.33.37.54.09.21.15.45.15.7Z" />
                </G>
            </G>
        </Svg>
    );
};
export { SvgComponent as NukeIcon };

const styles = StyleSheet.create({
    luminance: {
        maskType: 'luminance',
    },
});
